import type { CSSProperties } from "react";
import {
    FA_640_VIEWBOX,
    type IconName,
    evenOddIcons,
    fa640ScaledIcons,
    pathFillOpacities,
    pathsFor,
} from "@plura/shared/icon-glyphs";

export type { IconName };

type IconProps = {
    className?: string;
    name: IconName;
    fill?: string;
    style?: CSSProperties;
};

const Icon = ({ className, name, fill, style }: IconProps) => (
    <svg
        className={`inline-flex size-6 ${className || ""}`}
        width={24}
        height={24}
        viewBox="0 0 24 24"
        style={style}
    >
        {pathsFor(name).map((d, i) => (
            <path
                key={i}
                fill={fill}
                fillOpacity={pathFillOpacities[name]?.[i]}
                fillRule={evenOddIcons.has(name) ? "evenodd" : undefined}
                transform={
                    fa640ScaledIcons.has(name) ? `scale(${24 / FA_640_VIEWBOX})` : undefined
                }
                d={d}
            ></path>
        ))}
    </svg>
);

export default Icon;
